import { render } from "./AgeGate.vue?vue&type=template&id=5095a389&ts=true"
import script from "./AgeGate.vue?vue&type=script&lang=ts"
export * from "./AgeGate.vue?vue&type=script&lang=ts"

import "./AgeGate.vue?vue&type=style&index=0&id=5095a389&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__